import { Box, Button, Checkbox, FormControlLabel, Grid } from "@mui/material";
import requests from "api/requests";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { DriverRequestAtpSettingsSerializer } from "./types";

interface IProps {
  atpID: number;
  settings: DriverRequestAtpSettingsSerializer;
  onChanged: () => void;
}


export default function DriverRequestSettings(props: IProps) {
  const {
    atpID,
    settings,
    onChanged
  } = props;

  const { enqueueSnackbar } = useSnackbar();
  const [instance, setInstance] = useState<DriverRequestAtpSettingsSerializer>({ ...settings });
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    setInstance({ ...settings })
  }, [settings])

  const save = () => {
    setDisable(true);
    requests.patch(`/atp/atp/${atpID}/`, {
      "driver_request_settings": instance
    }).then((r) => {
      onChanged()
      enqueueSnackbar("Збережено", { variant: 'success' });
    }).finally(() => {
      setDisable(false);
    })
  }


  return (
    <Box>
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <FormControlLabel control={
            <Checkbox
              checked={instance.is_need_drivers || false}
              onChange={(_, checked) => {
                setInstance((o) => {
                  o.is_need_drivers = checked
                  return { ...o }
                })
              }}
              size="small"
            />
          } label={"Пошук водіїв"} />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControlLabel control={
            <Checkbox
              checked={instance.is_level_1 || false}
              onChange={(_, checked) => {
                setInstance((o) => {
                  o.is_level_1 = checked
                  return { ...o }
                })
              }}
              size="small"
            />
          } label={"1-й рівень"} />
        </Grid>
      </Grid>
      <Box sx={{
        mt: 2
      }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={save}
          disabled={disable}
        >Зберегти</Button>
      </Box>
    </Box>
  )
}